var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "app-main-inner edi-selector-dialog custom-dialog",
          attrs: {
            visible: _vm.innerVisible,
            width: _vm.isHPL || _vm.isHMM ? "1230px" : "1770px",
            top: "2.6vh",
            title: _vm.title,
            "close-on-click-modal": false,
            "destroy-on-close": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _vm.isHPL
            ? [
                _c(
                  "el-button",
                  {
                    staticStyle: { margin: "10px 0 0 15px" },
                    attrs: {
                      no: "CopyBusinessSendConsigneeNotify",
                      type: "primary"
                    },
                    on: {
                      click: function($event) {
                        _vm.euBolHplCopyDialog.visible = true
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t("SeaExport.CopyBusinessSendConsigneeNotify")
                      )
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "custom-dialog-content",
                    staticStyle: { width: "fit-content", display: "flex" }
                  },
                  [
                    _c("div", { staticClass: "vertical-line" }),
                    _c(
                      "div",
                      { staticClass: "form-section" },
                      [
                        _c(
                          "el-form",
                          {
                            attrs: {
                              "label-width": "120px",
                              "label-position": "right"
                            }
                          },
                          [
                            _c(
                              "div",
                              [
                                _c("span", { staticClass: "title" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.DeclarationInformation")
                                    )
                                  )
                                ]),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "lable-blue",
                                    staticStyle: { width: "350px" },
                                    attrs: {
                                      no: "ENSDeclaration",
                                      label: _vm.$t(
                                        "SeaExport.EuroLineENSDeclaration"
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        ref: "euEnsFilingTag",
                                        attrs: {
                                          label: _vm.$t(
                                            "SeaExport.EuroLineENSDeclaration"
                                          ),
                                          placeholder: " "
                                        },
                                        on: {
                                          change: _vm.onEuEnsFilingTagChange
                                        },
                                        model: {
                                          value: _vm.form.euEnsFilingTag,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "euEnsFilingTag",
                                              $$v
                                            )
                                          },
                                          expression: "form.euEnsFilingTag"
                                        }
                                      },
                                      _vm._l(
                                        _vm.SeaExportConstants
                                          .ENS_DECLARATION_HPL,
                                        function(item, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label:
                                                _vm.$store.getters.language ===
                                                "zh"
                                                  ? item.chineseName
                                                  : item.englishName,
                                              value: item.code
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { width: "350px" },
                                    attrs: { no: "supplementaryDeclarant" }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        class:
                                          _vm.form.euEnsFilingTag ===
                                            _vm.SeaExportConstants
                                              .ENS_DECLARATION_STRAIGHT_SUPPLEMENTARY
                                              .code ||
                                          _vm.form.euEnsFilingTag ===
                                            _vm.SeaExportConstants
                                              .ENS_DECLARATION_HOUSE_SELF
                                              .code ||
                                          _vm.form.euEnsFilingTag ===
                                            _vm.SeaExportConstants
                                              .ENS_DECLARATION_HOUSE_MIXED.code
                                            ? "blue"
                                            : "",
                                        attrs: { slot: "label" },
                                        slot: "label"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "SeaExport.SupplementaryDeclarant"
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    ),
                                    _c("el-input", {
                                      ref: "supplementaryDeclarantEoriNo",
                                      attrs: {
                                        type: "text",
                                        "filter-chars": false
                                      },
                                      on: {
                                        change:
                                          _vm.onSupplementaryDeclarantChange
                                      },
                                      model: {
                                        value:
                                          _vm.form.supplementaryDeclarantEoriNo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "supplementaryDeclarantEoriNo",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.supplementaryDeclarantEoriNo"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { width: "350px" },
                                    attrs: { no: "chemicalType" }
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "blue",
                                      attrs: { slot: "label" },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t("SeaExport.ChemicalIdentifier")
                                        )
                                      },
                                      slot: "label"
                                    }),
                                    _c(
                                      "el-select",
                                      {
                                        ref: "chemicalTag",
                                        attrs: { no: "chemicalTag" },
                                        model: {
                                          value: _vm.form.chemicalTag,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "chemicalTag",
                                              $$v
                                            )
                                          },
                                          expression: "form.chemicalTag"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.ChemicalProduct"
                                            ),
                                            value: true
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.NonChemicalProduct"
                                            ),
                                            value: false
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { width: "350px" },
                                    attrs: {
                                      no: "ucrNo",
                                      label: _vm.$t("SeaExport.UCRNO")
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      ref: "ucrNo",
                                      attrs: {
                                        type: "text",
                                        "filter-chars": false
                                      },
                                      model: {
                                        value: _vm.form.ucrNo,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "ucrNo", $$v)
                                        },
                                        expression: "form.ucrNo"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "SeaExport.ActualShipperCountry"
                                      )
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      ref: "shipperCountry",
                                      attrs: {
                                        no: "shipperCountry",
                                        "select-type":
                                          _vm.TYPE_NAMES.basic_data_Country,
                                        filterable: "",
                                        "tag-name": "code",
                                        "show-custom-label-in-option": true,
                                        "custom-label": function(p) {
                                          return p.code + "（" + p.name + "）"
                                        },
                                        "default-value": _vm.form.shipperCountry
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.form.shipperCountry = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("SeaExport.ShipperEORI")
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      ref: "shipperIdNumber",
                                      attrs: {
                                        no: "4",
                                        type: "text",
                                        "filter-chars": false
                                      },
                                      model: {
                                        value: _vm.form.shipperIdNumber,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "shipperIdNumber",
                                            $$v
                                          )
                                        },
                                        expression: "form.shipperIdNumber"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "SeaExport.ActualRecipientCountry"
                                      )
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      ref: "consigneeCountry",
                                      attrs: {
                                        no: "consigneeCountry",
                                        "select-type":
                                          _vm.TYPE_NAMES.basic_data_Country,
                                        filterable: "",
                                        "tag-name": "code",
                                        "show-custom-label-in-option": true,
                                        "custom-label": function(p) {
                                          return p.code + "（" + p.name + "）"
                                        },
                                        "default-value":
                                          _vm.form.consigneeCountry
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.form.consigneeCountry = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("SeaExport.ConsigneeEORI")
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      ref: "consigneeId",
                                      attrs: {
                                        no: "9",
                                        type: "text",
                                        "filter-chars": false
                                      },
                                      model: {
                                        value: _vm.form.consigneeId,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "consigneeId", $$v)
                                        },
                                        expression: "form.consigneeId"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "SeaExport.NotificationCountry"
                                      )
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      ref: "notifyCountry",
                                      attrs: {
                                        no: "notifyCountry",
                                        "select-type":
                                          _vm.TYPE_NAMES.basic_data_Country,
                                        filterable: "",
                                        "tag-name": "code",
                                        "show-custom-label-in-option": true,
                                        "custom-label": function(p) {
                                          return p.code + "（" + p.name + "）"
                                        },
                                        "default-value": _vm.form.notifyCountry
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.form.notifyCountry = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("SeaExport.NotifyEORI")
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      ref: "notifyCodeForManifest",
                                      attrs: {
                                        no: "14",
                                        type: "text",
                                        "filter-chars": false
                                      },
                                      model: {
                                        value: _vm.form.notifyCodeForManifest,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "notifyCodeForManifest",
                                            $$v
                                          )
                                        },
                                        expression: "form.notifyCodeForManifest"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { width: "350px" },
                                    attrs: {
                                      no: "factoryIdNumber",
                                      label: _vm.$t("SeaExport.FactoryEORI")
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      ref: "factoryIdNumber",
                                      attrs: {
                                        type: "text",
                                        "filter-chars": false
                                      },
                                      model: {
                                        value: _vm.form.factoryIdNumber,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "factoryIdNumber",
                                            $$v
                                          )
                                        },
                                        expression: "form.factoryIdNumber"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { width: "350px" },
                                    attrs: {
                                      no: "warehouseIdNumber",
                                      label: _vm.$t("SeaExport.WarehouseEORI")
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      ref: "warehouseIdNumber",
                                      attrs: {
                                        type: "text",
                                        "filter-chars": false
                                      },
                                      model: {
                                        value: _vm.form.warehouseIdNumber,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "warehouseIdNumber",
                                            $$v
                                          )
                                        },
                                        expression: "form.warehouseIdNumber"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { width: "350px" },
                                    attrs: {
                                      no: "lclPersonIdNumber",
                                      label: _vm.$t("SeaExport.LCLPersonEORI")
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      ref: "lclPersonIdNumber",
                                      attrs: {
                                        type: "text",
                                        "filter-chars": false
                                      },
                                      model: {
                                        value: _vm.form.lclPersonIdNumber,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "lclPersonIdNumber",
                                            $$v
                                          )
                                        },
                                        expression: "form.lclPersonIdNumber"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c("div", { staticClass: "vertical-line" }),
                    _c(
                      "div",
                      { staticClass: "form-section" },
                      [
                        _c(
                          "el-form",
                          {
                            attrs: {
                              "label-width": "120px",
                              "label-position": "right"
                            }
                          },
                          [
                            _c(
                              "div",
                              [
                                _vm.form.euEnsFilingTag ===
                                  _vm.SeaExportConstants
                                    .ENS_DECLARATION_HOUSE_CARRIER.code ||
                                _vm.form.euEnsFilingTag ===
                                  _vm.SeaExportConstants
                                    .ENS_DECLARATION_HOUSE_MIXED.code
                                  ? [
                                      _c("span", { staticClass: "title" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("SeaExport.ActualShipper")
                                          )
                                        )
                                      ]),
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "custom-button",
                                          attrs: {
                                            no: "copyActualShipper",
                                            type: "primary"
                                          },
                                          on: { click: _vm.copyActualShipper }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "SeaExport.CopyActualShipper"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "lable-blue",
                                          staticStyle: { width: "400px" },
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.ShipperName"
                                            )
                                          }
                                        },
                                        [
                                          _c("cargo-rich-textarea", {
                                            ref: "actualShipperName",
                                            staticStyle: {
                                              "min-height": "28px"
                                            },
                                            attrs: {
                                              placeholder: _vm.$t(
                                                "SeaExport.Name"
                                              ),
                                              no: "17",
                                              "warning-count": _vm.warningCount,
                                              "is-trim": true,
                                              "disable-enter": true
                                            },
                                            nativeOn: {
                                              dblclick: function($event) {
                                                _vm.showNameAddressDialog(
                                                  _vm.$t(
                                                    "SeaExport.ActualShipper"
                                                  ),
                                                  "actualShipperName",
                                                  "actualShipperAddress"
                                                )
                                              }
                                            },
                                            model: {
                                              value: _vm.form.actualShipperName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "actualShipperName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.actualShipperName"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        { staticStyle: { width: "400px" } },
                                        [
                                          _c("span", {
                                            staticClass: "blue",
                                            attrs: { slot: "label" },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t(
                                                  "SeaExport.ShipperAddress"
                                                )
                                              )
                                            },
                                            slot: "label"
                                          }),
                                          _c("cargo-rich-textarea", {
                                            ref: "actualShipperAddress",
                                            staticStyle: {
                                              "min-height": "70px"
                                            },
                                            attrs: {
                                              no: "18",
                                              "warning-count": _vm.warningCount,
                                              "is-trim": true
                                            },
                                            nativeOn: {
                                              dblclick: function($event) {
                                                _vm.showNameAddressDialog(
                                                  _vm.$t(
                                                    "SeaExport.ActualShipper"
                                                  ),
                                                  "actualShipperName",
                                                  "actualShipperAddress"
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.form.actualShipperAddress,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "actualShipperAddress",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.actualShipperAddress"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: { width: "400px" },
                                          attrs: {
                                            label: _vm.$t("SeaExport.EORICode")
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            ref: "actualShipperCodeForManifest",
                                            attrs: {
                                              no: "22",
                                              type: "text",
                                              "filter-chars": false
                                            },
                                            model: {
                                              value:
                                                _vm.form
                                                  .actualShipperCodeForManifest,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "actualShipperCodeForManifest",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.actualShipperCodeForManifest"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: { width: "400px" },
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.ShipperZipCode"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            ref: "actualShipperPostalCode",
                                            attrs: {
                                              no: "23",
                                              type: "text",
                                              "filter-chars": false
                                            },
                                            model: {
                                              value:
                                                _vm.form
                                                  .actualShipperPostalCode,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "actualShipperPostalCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.actualShipperPostalCode"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: { width: "400px" },
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.ActualShipperCountry"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" }
                                            },
                                            [
                                              _c("cargo-advance-select", {
                                                ref: "actualShipperCountry",
                                                attrs: {
                                                  no: "actualShipperCountry",
                                                  "select-type":
                                                    _vm.TYPE_NAMES
                                                      .basic_data_Country,
                                                  filterable: "",
                                                  "tag-name": "code",
                                                  "show-custom-label-in-option": true,
                                                  "custom-label": function(p) {
                                                    return (
                                                      p.code +
                                                      "（" +
                                                      p.name +
                                                      "）"
                                                    )
                                                  },
                                                  "default-value":
                                                    _vm.form
                                                      .actualShipperCountry
                                                },
                                                on: {
                                                  parentCallBack: function(p) {
                                                    _vm.form.actualShipperCountry =
                                                      p.value
                                                  }
                                                }
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    width: "170px",
                                                    "text-align": "center",
                                                    color: "black"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "SeaExport.ActualShipperCity"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c("el-input", {
                                                ref: "actualShipperCity",
                                                attrs: {
                                                  no: "actualShipperCity",
                                                  type: "text",
                                                  "filter-chars": false
                                                },
                                                model: {
                                                  value:
                                                    _vm.form.actualShipperCity,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "actualShipperCity",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.actualShipperCity"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ]
                                  : _vm._e(),
                                _vm.form.euEnsFilingTag ===
                                  _vm.SeaExportConstants
                                    .ENS_DECLARATION_HOUSE_CARRIER.code ||
                                _vm.form.euEnsFilingTag ===
                                  _vm.SeaExportConstants
                                    .ENS_DECLARATION_HOUSE_MIXED.code
                                  ? [
                                      _c("span", { staticClass: "title" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("SeaExport.ActualConsignee")
                                          )
                                        )
                                      ]),
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "custom-button",
                                          attrs: {
                                            no: "copyBusiness",
                                            type: "primary"
                                          },
                                          on: { click: _vm.copyActualConsignee }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "SeaExport.CopyActualConsignee"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "lable-blue",
                                          staticStyle: { width: "400px" },
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.ConsigneeName"
                                            )
                                          }
                                        },
                                        [
                                          _c("cargo-rich-textarea", {
                                            ref: "actualConsigneeName",
                                            staticStyle: {
                                              "min-height": "28px"
                                            },
                                            attrs: {
                                              placeholder: _vm.$t(
                                                "SeaExport.Name"
                                              ),
                                              no: "24",
                                              "warning-count": _vm.warningCount,
                                              "is-trim": true,
                                              "disable-enter": true
                                            },
                                            nativeOn: {
                                              dblclick: function($event) {
                                                _vm.showNameAddressDialog(
                                                  _vm.$t(
                                                    "SeaExport.ActualConsignee"
                                                  ),
                                                  "actualConsigneeName",
                                                  "actualConsigneeAddress"
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.form.actualConsigneeName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "actualConsigneeName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.actualConsigneeName"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        { staticStyle: { width: "400px" } },
                                        [
                                          _c("span", {
                                            staticClass: "blue",
                                            attrs: { slot: "label" },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t(
                                                  "SeaExport.ConsigneeAddress"
                                                )
                                              )
                                            },
                                            slot: "label"
                                          }),
                                          _c("cargo-rich-textarea", {
                                            ref: "actualConsigneeAddress",
                                            staticStyle: {
                                              "min-height": "70px"
                                            },
                                            attrs: {
                                              no: "25",
                                              type: "textarea",
                                              "warning-count": _vm.warningCount,
                                              "is-trim": true
                                            },
                                            nativeOn: {
                                              dblclick: function($event) {
                                                _vm.showNameAddressDialog(
                                                  _vm.$t(
                                                    "SeaExport.ActualConsignee"
                                                  ),
                                                  "actualConsigneeName",
                                                  "actualConsigneeAddress"
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.form.actualConsigneeAddress,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "actualConsigneeAddress",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.actualConsigneeAddress"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm.form.euEnsFilingTag ===
                                        _vm.SeaExportConstants
                                          .ENS_DECLARATION_HOUSE_CARRIER.code ||
                                      _vm.form.euEnsFilingTag ===
                                        _vm.SeaExportConstants
                                          .ENS_DECLARATION_HOUSE_MIXED.code
                                        ? _c(
                                            "el-form-item",
                                            {
                                              staticStyle: { width: "400px" },
                                              attrs: {
                                                label: _vm.$t(
                                                  "SeaExport.EORICode"
                                                )
                                              }
                                            },
                                            [
                                              _c("el-input", {
                                                ref: "actualConsigneeIdNumber",
                                                attrs: {
                                                  no: "29",
                                                  type: "text",
                                                  "filter-chars": false
                                                },
                                                model: {
                                                  value:
                                                    _vm.form
                                                      .actualConsigneeIdNumber,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "actualConsigneeIdNumber",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.actualConsigneeIdNumber"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: { width: "400px" },
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.ConsigneeZipCode"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            ref:
                                              "actualConsigneeCodeForManifest",
                                            attrs: {
                                              no: "30",
                                              type: "text",
                                              "filter-chars": false
                                            },
                                            model: {
                                              value:
                                                _vm.form
                                                  .actualConsigneeCodeForManifest,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "actualConsigneeCodeForManifest",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.actualConsigneeCodeForManifest"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: { width: "400px" },
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.ActualRecipientCountry"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" }
                                            },
                                            [
                                              _c("cargo-advance-select", {
                                                ref: "actualConsigneeCountry",
                                                attrs: {
                                                  no: "actualConsigneeCountry",
                                                  "select-type":
                                                    _vm.TYPE_NAMES
                                                      .basic_data_Country,
                                                  filterable: "",
                                                  "tag-name": "code",
                                                  "show-custom-label-in-option": true,
                                                  "custom-label": function(p) {
                                                    return (
                                                      p.code +
                                                      "（" +
                                                      p.name +
                                                      "）"
                                                    )
                                                  },
                                                  "default-value":
                                                    _vm.form
                                                      .actualConsigneeCountry
                                                },
                                                on: {
                                                  parentCallBack: function(p) {
                                                    _vm.form.actualConsigneeCountry =
                                                      p.value
                                                  }
                                                }
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    width: "170px",
                                                    "text-align": "center",
                                                    color: "black"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "SeaExport.ActualRecipientCity"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c("el-input", {
                                                ref: "actualConsigneeCity",
                                                attrs: {
                                                  no: "actualConsigneeCity",
                                                  type: "text",
                                                  "filter-chars": false
                                                },
                                                model: {
                                                  value:
                                                    _vm.form
                                                      .actualConsigneeCity,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "actualConsigneeCity",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.actualConsigneeCity"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c("div", { staticClass: "vertical-line" }),
                    _vm.form.euEnsFilingTag !==
                    _vm.SeaExportConstants.ENS_DECLARATION_HOUSE_MIXED.code
                      ? _c(
                          "div",
                          { staticClass: "form-section" },
                          [
                            _c(
                              "el-form",
                              {
                                attrs: {
                                  "label-width": "120px",
                                  "label-position": "right"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  [
                                    _vm.form.euEnsFilingTag ===
                                      _vm.SeaExportConstants
                                        .ENS_DECLARATION_HOUSE_CARRIER.code ||
                                    _vm.form.euEnsFilingTag ===
                                      _vm.SeaExportConstants
                                        .ENS_DECLARATION_HOUSE_MIXED.code ||
                                    _vm.form.euEnsFilingTag ===
                                      _vm.SeaExportConstants
                                        .ENS_DECLARATION_STRAIGHT_CARRIER.code
                                      ? [
                                          _c("span", { staticClass: "title" }, [
                                            _vm._v(
                                              _vm._s(_vm.$t("SeaExport.Buyer"))
                                            )
                                          ]),
                                          _c(
                                            "el-form-item",
                                            {
                                              staticClass: "lable-blue",
                                              staticStyle: { width: "400px" },
                                              attrs: {
                                                label: _vm.$t(
                                                  "SeaExport.BuyerName"
                                                )
                                              }
                                            },
                                            [
                                              _c("cargo-rich-textarea", {
                                                ref: "buyerName",
                                                staticStyle: {
                                                  "min-height": "28px"
                                                },
                                                attrs: {
                                                  no: "buyerName",
                                                  placeholder: _vm.$t(
                                                    "SeaExport.Name"
                                                  ),
                                                  "warning-count":
                                                    _vm.warningCount,
                                                  "is-trim": true,
                                                  "disable-enter": true
                                                },
                                                nativeOn: {
                                                  dblclick: function($event) {
                                                    _vm.showNameAddressDialog(
                                                      _vm.$t("SeaExport.Buyer"),
                                                      "buyerName",
                                                      "buyerAddress"
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value: _vm.form.buyerName,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "buyerName",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.buyerName"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            { staticStyle: { width: "400px" } },
                                            [
                                              _c("span", {
                                                staticClass: "blue",
                                                attrs: { slot: "label" },
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.$t(
                                                      "SeaExport.BuyerAddress"
                                                    )
                                                  )
                                                },
                                                slot: "label"
                                              }),
                                              _c("cargo-rich-textarea", {
                                                ref: "buyerAddress",
                                                staticStyle: {
                                                  "min-height": "70px"
                                                },
                                                attrs: {
                                                  no: "buyerAddress",
                                                  "warning-count":
                                                    _vm.warningCount,
                                                  "is-trim": true
                                                },
                                                nativeOn: {
                                                  dblclick: function($event) {
                                                    _vm.showNameAddressDialog(
                                                      _vm.$t("SeaExport.Buyer"),
                                                      "buyerName",
                                                      "buyerAddress"
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value: _vm.form.buyerAddress,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "buyerAddress",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.buyerAddress"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm.form.euEnsFilingTag ===
                                            _vm.SeaExportConstants
                                              .ENS_DECLARATION_HOUSE_CARRIER
                                              .code ||
                                          _vm.form.euEnsFilingTag ===
                                            _vm.SeaExportConstants
                                              .ENS_DECLARATION_STRAIGHT_CARRIER
                                              .code
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  staticStyle: {
                                                    width: "400px"
                                                  },
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "SeaExport.EORICode"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    ref: "buyerIdNumber",
                                                    attrs: {
                                                      no: "buyerIdNumber",
                                                      type: "text",
                                                      "filter-chars": false
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form.buyerIdNumber,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "buyerIdNumber",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.buyerIdNumber"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "el-form-item",
                                            {
                                              staticStyle: { width: "400px" },
                                              attrs: {
                                                label: _vm.$t(
                                                  "SeaExport.BuyerPostalCode"
                                                )
                                              }
                                            },
                                            [
                                              _c("el-input", {
                                                ref: "buyerPostalCode",
                                                attrs: {
                                                  no: "buyerPostalCode",
                                                  type: "text",
                                                  "filter-chars": false
                                                },
                                                model: {
                                                  value:
                                                    _vm.form.buyerPostalCode,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "buyerPostalCode",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.buyerPostalCode"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              staticStyle: { width: "400px" },
                                              attrs: {
                                                label: _vm.$t(
                                                  "SeaExport.BuyerCountry"
                                                )
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex"
                                                  }
                                                },
                                                [
                                                  _c("cargo-advance-select", {
                                                    ref: "buyerCountry",
                                                    attrs: {
                                                      no: "buyerCountry",
                                                      "select-type":
                                                        _vm.TYPE_NAMES
                                                          .basic_data_Country,
                                                      filterable: "",
                                                      "tag-name": "code",
                                                      "show-custom-label-in-option": true,
                                                      "custom-label": function(
                                                        p
                                                      ) {
                                                        return (
                                                          p.code +
                                                          "（" +
                                                          p.name +
                                                          "）"
                                                        )
                                                      },
                                                      "default-value":
                                                        _vm.form.buyerCountry
                                                    },
                                                    on: {
                                                      parentCallBack: function(
                                                        p
                                                      ) {
                                                        _vm.form.buyerCountry =
                                                          p.value
                                                      }
                                                    }
                                                  }),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        width: "170px",
                                                        "text-align": "center",
                                                        color: "black"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "SeaExport.BuyerCity"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _c("el-input", {
                                                    ref: "buyerCity",
                                                    attrs: {
                                                      no: "buyerCity",
                                                      type: "text",
                                                      "filter-chars": false
                                                    },
                                                    model: {
                                                      value: _vm.form.buyerCity,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "buyerCity",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.buyerCity"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm.form.euEnsFilingTag ===
                                      _vm.SeaExportConstants
                                        .ENS_DECLARATION_HOUSE_CARRIER.code ||
                                    _vm.form.euEnsFilingTag ===
                                      _vm.SeaExportConstants
                                        .ENS_DECLARATION_HOUSE_MIXED.code ||
                                    _vm.form.euEnsFilingTag ===
                                      _vm.SeaExportConstants
                                        .ENS_DECLARATION_STRAIGHT_CARRIER.code
                                      ? [
                                          _c("span", { staticClass: "title" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "RailwayExport.BoxOwner2"
                                                )
                                              )
                                            )
                                          ]),
                                          _c(
                                            "el-form-item",
                                            {
                                              staticClass: "lable-blue",
                                              staticStyle: { width: "400px" },
                                              attrs: {
                                                label: _vm.$t(
                                                  "SeaExport.SellerName"
                                                )
                                              }
                                            },
                                            [
                                              _c("cargo-rich-textarea", {
                                                ref: "sellerName",
                                                staticStyle: {
                                                  "min-height": "28px"
                                                },
                                                attrs: {
                                                  placeholder: _vm.$t(
                                                    "SeaExport.Name"
                                                  ),
                                                  no: "sellerName",
                                                  "warning-count":
                                                    _vm.warningCount,
                                                  "is-trim": true,
                                                  "disable-enter": true
                                                },
                                                nativeOn: {
                                                  dblclick: function($event) {
                                                    _vm.showNameAddressDialog(
                                                      _vm.$t(
                                                        "RailwayExport.BoxOwner2"
                                                      ),
                                                      "sellerName",
                                                      "sellerAddress"
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value: _vm.form.sellerName,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "sellerName",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.sellerName"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            { staticStyle: { width: "400px" } },
                                            [
                                              _c("span", {
                                                staticClass: "blue",
                                                attrs: { slot: "label" },
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.$t(
                                                      "SeaExport.SellerAddress"
                                                    )
                                                  )
                                                },
                                                slot: "label"
                                              }),
                                              _c("cargo-rich-textarea", {
                                                ref: "sellerAddress",
                                                staticStyle: {
                                                  "min-height": "70px"
                                                },
                                                attrs: {
                                                  no: "sellerAddress",
                                                  "warning-count":
                                                    _vm.warningCount,
                                                  "is-trim": true
                                                },
                                                nativeOn: {
                                                  dblclick: function($event) {
                                                    _vm.showNameAddressDialog(
                                                      _vm.$t(
                                                        "RailwayExport.BoxOwner2"
                                                      ),
                                                      "sellerName",
                                                      "sellerAddress"
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value: _vm.form.sellerAddress,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "sellerAddress",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.sellerAddress"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm.form.euEnsFilingTag ===
                                            _vm.SeaExportConstants
                                              .ENS_DECLARATION_HOUSE_CARRIER
                                              .code ||
                                          _vm.form.euEnsFilingTag ===
                                            _vm.SeaExportConstants
                                              .ENS_DECLARATION_STRAIGHT_CARRIER
                                              .code
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  staticStyle: {
                                                    width: "400px"
                                                  },
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "SeaExport.EORICode"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    ref: "sellerIdNumber",
                                                    attrs: {
                                                      no: "sellerIdNumber",
                                                      type: "text",
                                                      "filter-chars": false
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form.sellerIdNumber,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "sellerIdNumber",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.sellerIdNumber"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "el-form-item",
                                            {
                                              staticStyle: { width: "400px" },
                                              attrs: {
                                                label: _vm.$t(
                                                  "SeaExport.SellerPostalCode"
                                                )
                                              }
                                            },
                                            [
                                              _c("el-input", {
                                                ref: "sellerPostalCode",
                                                attrs: {
                                                  no: "sellerPostalCode",
                                                  type: "text",
                                                  "filter-chars": false
                                                },
                                                model: {
                                                  value:
                                                    _vm.form.sellerPostalCode,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "sellerPostalCode",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.sellerPostalCode"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              staticStyle: { width: "400px" },
                                              attrs: {
                                                label: _vm.$t(
                                                  "SeaExport.SellerCountry"
                                                )
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex"
                                                  }
                                                },
                                                [
                                                  _c("cargo-advance-select", {
                                                    ref: "sellerCountry",
                                                    attrs: {
                                                      no: "sellerCountry",
                                                      "select-type":
                                                        _vm.TYPE_NAMES
                                                          .basic_data_Country,
                                                      filterable: "",
                                                      "tag-name": "code",
                                                      "show-custom-label-in-option": true,
                                                      "custom-label": function(
                                                        p
                                                      ) {
                                                        return (
                                                          p.code +
                                                          "（" +
                                                          p.name +
                                                          "）"
                                                        )
                                                      },
                                                      "default-value":
                                                        _vm.form.sellerCountry
                                                    },
                                                    on: {
                                                      parentCallBack: function(
                                                        p
                                                      ) {
                                                        _vm.form.sellerCountry =
                                                          p.value
                                                      }
                                                    }
                                                  }),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        width: "170px",
                                                        "text-align": "center",
                                                        color: "black"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "SeaExport.SellerCity"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _c("el-input", {
                                                    ref: "sellerCity",
                                                    attrs: {
                                                      no: "sellerCity",
                                                      type: "text",
                                                      "filter-chars": false
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form.sellerCity,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "sellerCity",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.sellerCity"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                )
              ]
            : _vm._e(),
          _vm.isHMM
            ? [
                _c(
                  "div",
                  {
                    staticClass: "custom-dialog-content",
                    staticStyle: { width: "fit-content", display: "flex" }
                  },
                  [
                    _c("div", { staticClass: "vertical-line" }),
                    _c(
                      "div",
                      { staticClass: "form-section" },
                      [
                        _c(
                          "el-form",
                          {
                            attrs: {
                              "label-width": "120px",
                              "label-position": "right"
                            }
                          },
                          [
                            _c(
                              "div",
                              [
                                _c("div", { staticStyle: { height: "10px" } }),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "lable-blue",
                                    staticStyle: { width: "350px" },
                                    attrs: {
                                      no: "ENSDeclaration",
                                      label: _vm.$t(
                                        "SeaExport.EuroLineENSDeclaration"
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "SeaExport.EuroLineENSDeclaration"
                                          ),
                                          placeholder: _vm.$t(
                                            "SeaExport.SelectEuroLineENSDeclaration"
                                          )
                                        },
                                        model: {
                                          value: _vm.form.euEnsFilingTag,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "euEnsFilingTag",
                                              $$v
                                            )
                                          },
                                          expression: "form.euEnsFilingTag"
                                        }
                                      },
                                      _vm._l(
                                        _vm.SeaExportConstants.ENS_DECLARATION,
                                        function(item, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label:
                                                _vm.$store.getters.language ===
                                                "zh"
                                                  ? item.chineseName
                                                  : item.englishName,
                                              value: item.code
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "lable-blue",
                                    staticStyle: { width: "350px" },
                                    attrs: {
                                      no: "manifestType",
                                      label: _vm.$t("SeaExport.ManifestType")
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "SeaExport.ManifestType"
                                          ),
                                          placeholder: _vm.$t(
                                            "SeaExport.SelectManifestType"
                                          )
                                        },
                                        model: {
                                          value: _vm.form.manifestType,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "manifestType",
                                              $$v
                                            )
                                          },
                                          expression: "form.manifestType"
                                        }
                                      },
                                      _vm._l(
                                        _vm.SeaExportConstants.MANIFEST_TYPE,
                                        function(item, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label:
                                                _vm.$store.getters.language ===
                                                "zh"
                                                  ? item.chineseName
                                                  : item.englishName,
                                              value: item.code
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { width: "350px" },
                                    attrs: {
                                      no: "supplementaryDeclarant",
                                      label: _vm.$t(
                                        "SeaExport.SupplementaryDeclarant"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        type: "text",
                                        "filter-chars": false
                                      },
                                      model: {
                                        value:
                                          _vm.form.supplementaryDeclarantEoriNo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "supplementaryDeclarantEoriNo",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.supplementaryDeclarantEoriNo"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { width: "350px" },
                                    attrs: {
                                      no: "chemicalType",
                                      label: _vm.$t(
                                        "SeaExport.ChemicalIdentifier"
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { no: "chemicalTag" },
                                        model: {
                                          value: _vm.form.chemicalTag,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "chemicalTag",
                                              $$v
                                            )
                                          },
                                          expression: "form.chemicalTag"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.ChemicalProduct"
                                            ),
                                            value: true
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.NonChemicalProduct"
                                            ),
                                            value: false
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c("div", { staticClass: "vertical-line" }),
                    _c(
                      "div",
                      { staticClass: "form-section" },
                      [
                        _c(
                          "el-form",
                          {
                            staticStyle: { width: "320px" },
                            attrs: {
                              "label-width": "160px",
                              "label-position": "right"
                            }
                          },
                          [
                            _c(
                              "div",
                              [
                                _c("span", { staticClass: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("SeaExport.Shipper")))
                                ]),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "custom-button",
                                    attrs: {
                                      no: "copyBusiness",
                                      type: "primary"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.euBolCopyDialog.visible = true
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.CopyBusiness"))
                                    )
                                  ]
                                ),
                                _c(
                                  "el-form-item",
                                  [
                                    _c("span", {
                                      staticClass: "blue",
                                      attrs: { slot: "label" },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t("SeaExport.PostalInformation2")
                                        )
                                      },
                                      slot: "label"
                                    }),
                                    _c("el-input", {
                                      attrs: {
                                        no: "1",
                                        type: "text",
                                        "filter-chars": false
                                      },
                                      model: {
                                        value: _vm.form.shipperPostalInfo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "shipperPostalInfo",
                                            $$v
                                          )
                                        },
                                        expression: "form.shipperPostalInfo"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "lable-blue",
                                    attrs: {
                                      label: _vm.$t(
                                        "SeaExport.ShipperStreetNumber"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        no: "2",
                                        type: "text",
                                        "filter-chars": false
                                      },
                                      model: {
                                        value: _vm.form.shipperStreetNo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "shipperStreetNo",
                                            $$v
                                          )
                                        },
                                        expression: "form.shipperStreetNo"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "lable-blue",
                                    attrs: {
                                      label: _vm.$t(
                                        "SeaExport.ShipperStreetName"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        no: "3",
                                        type: "text",
                                        "filter-chars": false
                                      },
                                      model: {
                                        value: _vm.form.shipperStreetName,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "shipperStreetName",
                                            $$v
                                          )
                                        },
                                        expression: "form.shipperStreetName"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      content: _vm.$t(
                                        "SeaExport.EORICodeExample"
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t("SeaExport.EORICode")
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder:
                                              _vm.$t(
                                                "SystemMaintenance.Example"
                                              ) + ":EORI+CZ28937668",
                                            no: "4",
                                            type: "text",
                                            "filter-chars": false
                                          },
                                          model: {
                                            value: _vm.form.shipperIdNumber,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "shipperIdNumber",
                                                $$v
                                              )
                                            },
                                            expression: "form.shipperIdNumber"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("SeaExport.ShipperZipCode")
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        no: "5",
                                        type: "text",
                                        "filter-chars": false
                                      },
                                      model: {
                                        value: _vm.form.shipperPostalCode,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "shipperPostalCode",
                                            $$v
                                          )
                                        },
                                        expression: "form.shipperPostalCode"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c("span", { staticClass: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("SeaExport.Consignee")))
                                ]),
                                _c(
                                  "el-form-item",
                                  [
                                    _c("span", {
                                      staticClass: "blue",
                                      attrs: { slot: "label" },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t("SeaExport.PostalInformation2")
                                        )
                                      },
                                      slot: "label"
                                    }),
                                    _c("el-input", {
                                      attrs: {
                                        no: "6",
                                        type: "text",
                                        "filter-chars": false
                                      },
                                      model: {
                                        value: _vm.form.consigneePostalInfo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "consigneePostalInfo",
                                            $$v
                                          )
                                        },
                                        expression: "form.consigneePostalInfo"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "lable-blue",
                                    attrs: {
                                      label: _vm.$t(
                                        "SeaExport.ConsigneeStreetNumber"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        no: "7",
                                        type: "text",
                                        "filter-chars": false
                                      },
                                      model: {
                                        value: _vm.form.consigneeStreetNo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "consigneeStreetNo",
                                            $$v
                                          )
                                        },
                                        expression: "form.consigneeStreetNo"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "lable-blue",
                                    attrs: {
                                      label: _vm.$t(
                                        "SeaExport.ConsigneeStreetName"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        no: "8",
                                        type: "text",
                                        "filter-chars": false
                                      },
                                      model: {
                                        value: _vm.form.consigneeStreetName,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "consigneeStreetName",
                                            $$v
                                          )
                                        },
                                        expression: "form.consigneeStreetName"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      content: _vm.$t(
                                        "SeaExport.EORICodeExample"
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t("SeaExport.EORICode")
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder:
                                              _vm.$t(
                                                "SystemMaintenance.Example"
                                              ) + ":EORI+CZ28937668",
                                            no: "9",
                                            type: "text",
                                            "filter-chars": false
                                          },
                                          model: {
                                            value: _vm.form.consigneeId,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "consigneeId",
                                                $$v
                                              )
                                            },
                                            expression: "form.consigneeId"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "SeaExport.ConsigneeZipCode"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        no: "10",
                                        type: "text",
                                        "filter-chars": false
                                      },
                                      model: {
                                        value: _vm.form.consigneePostalCode,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "consigneePostalCode",
                                            $$v
                                          )
                                        },
                                        expression: "form.consigneePostalCode"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c("span", { staticClass: "title" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.NotifyParty"))
                                  )
                                ]),
                                _c(
                                  "el-form-item",
                                  [
                                    _c("span", {
                                      attrs: { slot: "label" },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t("SeaExport.PostalInformation2")
                                        )
                                      },
                                      slot: "label"
                                    }),
                                    _c("el-input", {
                                      attrs: {
                                        no: "11",
                                        type: "text",
                                        placeholder: _vm.$t(
                                          "SeaExport.TOOrderRequired"
                                        ),
                                        "filter-chars": false
                                      },
                                      model: {
                                        value: _vm.form.notifyPostalInfo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "notifyPostalInfo",
                                            $$v
                                          )
                                        },
                                        expression: "form.notifyPostalInfo"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      content: _vm.$t(
                                        "SeaExport.TOOrderRequired"
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "SeaExport.NotifyStreetNumber"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            no: "12",
                                            type: "text",
                                            placeholder: _vm.$t(
                                              "SeaExport.TOOrderRequired"
                                            ),
                                            "filter-chars": false
                                          },
                                          model: {
                                            value: _vm.form.notifyStreetNo,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "notifyStreetNo",
                                                $$v
                                              )
                                            },
                                            expression: "form.notifyStreetNo"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      content: _vm.$t(
                                        "SeaExport.TOOrderRequired"
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "SeaExport.NotifyStreetName"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            no: "13",
                                            type: "text",
                                            placeholder: _vm.$t(
                                              "SeaExport.TOOrderRequired"
                                            ),
                                            "filter-chars": false
                                          },
                                          model: {
                                            value: _vm.form.notifyStreetName,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "notifyStreetName",
                                                $$v
                                              )
                                            },
                                            expression: "form.notifyStreetName"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      content: _vm.$t(
                                        "SeaExport.EORICodeExample"
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t("SeaExport.EORICode")
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "SeaExport.TOOrderRequired"
                                            ),
                                            no: "14",
                                            type: "text",
                                            "filter-chars": false
                                          },
                                          model: {
                                            value:
                                              _vm.form.notifyCodeForManifest,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "notifyCodeForManifest",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.notifyCodeForManifest"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      content: _vm.$t(
                                        "SeaExport.TOOrderRequired"
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "SeaExport.notifyingPhone"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            no: "15",
                                            type: "text",
                                            placeholder: _vm.$t(
                                              "SeaExport.TOOrderRequired"
                                            ),
                                            "filter-chars": false
                                          },
                                          model: {
                                            value: _vm.form.notifyPhone,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "notifyPhone",
                                                $$v
                                              )
                                            },
                                            expression: "form.notifyPhone"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("SeaExport.NotifyZipCode")
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        no: "16",
                                        type: "text",
                                        "filter-chars": false
                                      },
                                      model: {
                                        value: _vm.form.notifyPostalCode,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "notifyPostalCode",
                                            $$v
                                          )
                                        },
                                        expression: "form.notifyPostalCode"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c("div", { staticClass: "vertical-line" }),
                    _vm.form.euEnsFilingTag ===
                    _vm.SeaExportConstants.ENS_DECLARATION_B.code
                      ? _c(
                          "div",
                          { staticClass: "form-section" },
                          [
                            _c(
                              "el-form",
                              {
                                staticStyle: { width: "320px" },
                                attrs: {
                                  "label-width": "160px",
                                  "label-position": "right"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  [
                                    _c("span", { staticClass: "title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("SeaExport.ActualShipper")
                                        )
                                      )
                                    ]),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "custom-button",
                                        attrs: {
                                          no: "copyActualShipper",
                                          type: "primary"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.copyShipperOrConsignee(
                                              "shipper"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SeaExport.CopyActualShipper"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "lable-blue",
                                        attrs: {
                                          label: _vm.$t("SeaExport.ShipperName")
                                        }
                                      },
                                      [
                                        _c("cargo-rich-textarea", {
                                          staticStyle: { "min-height": "28px" },
                                          attrs: {
                                            no: "17",
                                            "warning-count": _vm.warningCount,
                                            "is-trim": true,
                                            "disable-enter": true
                                          },
                                          nativeOn: {
                                            dblclick: function($event) {
                                              _vm.showNameAddressDialog(
                                                _vm.$t(
                                                  "SeaExport.ActualShipper"
                                                ),
                                                "actualShipperName",
                                                "actualShipperAddress"
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.form.actualShipperName,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "actualShipperName",
                                                $$v
                                              )
                                            },
                                            expression: "form.actualShipperName"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "SeaExport.ShipperAddress"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-rich-textarea", {
                                          staticStyle: { "min-height": "70px" },
                                          attrs: {
                                            no: "18",
                                            "warning-count": _vm.warningCount,
                                            "is-trim": true
                                          },
                                          nativeOn: {
                                            dblclick: function($event) {
                                              _vm.showNameAddressDialog(
                                                _vm.$t(
                                                  "SeaExport.ActualShipper"
                                                ),
                                                "actualShipperName",
                                                "actualShipperAddress"
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.form.actualShipperAddress,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "actualShipperAddress",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.actualShipperAddress"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("span", {
                                          staticClass: "blue",
                                          attrs: { slot: "label" },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.$t(
                                                "SeaExport.PostalInformation2"
                                              )
                                            )
                                          },
                                          slot: "label"
                                        }),
                                        _c("el-input", {
                                          attrs: {
                                            no: "19",
                                            type: "text",
                                            "filter-chars": false
                                          },
                                          model: {
                                            value:
                                              _vm.form.actualShipperPostalInfo,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "actualShipperPostalInfo",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.actualShipperPostalInfo"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "lable-blue",
                                        attrs: {
                                          label: _vm.$t(
                                            "SeaExport.ShipperStreetNumber"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            no: "20",
                                            type: "text",
                                            "filter-chars": false
                                          },
                                          model: {
                                            value:
                                              _vm.form.actualShipperStreetNo,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "actualShipperStreetNo",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.actualShipperStreetNo"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "lable-blue",
                                        attrs: {
                                          label: _vm.$t(
                                            "SeaExport.ShipperStreetName"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            no: "21",
                                            type: "text",
                                            "filter-chars": false
                                          },
                                          model: {
                                            value:
                                              _vm.form.actualShipperStreetName,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "actualShipperStreetName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.actualShipperStreetName"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          content: _vm.$t(
                                            "SeaExport.EORICodeExample"
                                          )
                                        }
                                      },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "SeaExport.EORICode"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder:
                                                  _vm.$t(
                                                    "SystemMaintenance.Example"
                                                  ) + ":EORI+CZ28937668",
                                                no: "22",
                                                type: "text",
                                                "filter-chars": false
                                              },
                                              model: {
                                                value:
                                                  _vm.form
                                                    .actualShipperCodeForManifest,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "actualShipperCodeForManifest",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form.actualShipperCodeForManifest"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "SeaExport.ShipperZipCode"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            no: "23",
                                            type: "text",
                                            "filter-chars": false
                                          },
                                          model: {
                                            value:
                                              _vm.form.actualShipperPostalCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "actualShipperPostalCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.actualShipperPostalCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c("span", { staticClass: "title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("SeaExport.ActualConsignee")
                                        )
                                      )
                                    ]),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "custom-button",
                                        attrs: {
                                          no: "copyBusiness",
                                          type: "primary"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.copyShipperOrConsignee(
                                              "consignee"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SeaExport.CopyActualConsignee"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "lable-blue",
                                        attrs: {
                                          label: _vm.$t(
                                            "SeaExport.ConsigneeName"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-rich-textarea", {
                                          staticStyle: { "min-height": "28px" },
                                          attrs: {
                                            no: "24",
                                            "warning-count": _vm.warningCount,
                                            "is-trim": true,
                                            "disable-enter": true
                                          },
                                          nativeOn: {
                                            dblclick: function($event) {
                                              _vm.showNameAddressDialog(
                                                _vm.$t(
                                                  "SeaExport.ActualConsignee"
                                                ),
                                                "actualConsigneeName",
                                                "actualConsigneeAddress"
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.form.actualConsigneeName,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "actualConsigneeName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.actualConsigneeName"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "SeaExport.ConsigneeAddress"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-rich-textarea", {
                                          staticStyle: { "min-height": "70px" },
                                          attrs: {
                                            no: "25",
                                            "warning-count": _vm.warningCount,
                                            "is-trim": true
                                          },
                                          nativeOn: {
                                            dblclick: function($event) {
                                              _vm.showNameAddressDialog(
                                                _vm.$t(
                                                  "SeaExport.ActualConsignee"
                                                ),
                                                "actualConsigneeName",
                                                "actualConsigneeAddress"
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.form.actualConsigneeAddress,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "actualConsigneeAddress",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.actualConsigneeAddress"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("span", {
                                          staticClass: "blue",
                                          attrs: { slot: "label" },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.$t(
                                                "SeaExport.PostalInformation2"
                                              )
                                            )
                                          },
                                          slot: "label"
                                        }),
                                        _c("el-input", {
                                          attrs: {
                                            no: "26",
                                            type: "text",
                                            "filter-chars": false
                                          },
                                          model: {
                                            value:
                                              _vm.form
                                                .actualConsigneePostalInfo,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "actualConsigneePostalInfo",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.actualConsigneePostalInfo"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "lable-blue",
                                        attrs: {
                                          label: _vm.$t(
                                            "SeaExport.ConsigneeStreetNumber"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            no: "27",
                                            type: "text",
                                            "filter-chars": false
                                          },
                                          model: {
                                            value:
                                              _vm.form.actualConsigneeStreetNo,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "actualConsigneeStreetNo",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.actualConsigneeStreetNo"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "lable-blue",
                                        attrs: {
                                          label: _vm.$t(
                                            "SeaExport.ConsigneeStreetName"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            no: "28",
                                            type: "text",
                                            "filter-chars": false
                                          },
                                          model: {
                                            value:
                                              _vm.form
                                                .actualConsigneeStreetName,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "actualConsigneeStreetName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.actualConsigneeStreetName"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          content: _vm.$t(
                                            "SeaExport.EORICodeExample"
                                          )
                                        }
                                      },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "SeaExport.EORICode"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder:
                                                  _vm.$t(
                                                    "SystemMaintenance.Example"
                                                  ) + ":EORI+CZ28937668",
                                                no: "29",
                                                type: "text",
                                                "filter-chars": false
                                              },
                                              model: {
                                                value:
                                                  _vm.form
                                                    .actualConsigneeIdNumber,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "actualConsigneeIdNumber",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form.actualConsigneeIdNumber"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "SeaExport.ConsigneeZipCode"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            no: "30",
                                            type: "text",
                                            "filter-chars": false
                                          },
                                          model: {
                                            value:
                                              _vm.form
                                                .actualConsigneeCodeForManifest,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "actualConsigneeCodeForManifest",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.actualConsigneeCodeForManifest"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                )
              ]
            : _vm._e(),
          !_vm.isHPL && !_vm.isHMM
            ? [
                _c(
                  "el-button",
                  {
                    staticStyle: { margin: "10px 0 0 15px" },
                    attrs: {
                      no: "CopyBusinessSendConsigneeNotify",
                      type: "primary"
                    },
                    on: {
                      click: function($event) {
                        _vm.euBolOtherCopyDialog.visible = true
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t("SeaExport.CopyBusinessSendConsigneeNotify")
                      )
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "custom-dialog-content",
                    staticStyle: { width: "fit-content", display: "flex" }
                  },
                  [
                    _c("div", { staticClass: "vertical-line" }),
                    _c(
                      "div",
                      { staticClass: "form-section" },
                      [
                        _c(
                          "el-form",
                          {
                            attrs: {
                              "label-width": "120px",
                              "label-position": "right"
                            }
                          },
                          [
                            _c(
                              "div",
                              [
                                _c("span", { staticClass: "title" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.DeclarationInformation")
                                    )
                                  )
                                ]),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "lable-blue",
                                    staticStyle: { width: "350px" },
                                    attrs: {
                                      no: "ENSDeclaration",
                                      label: _vm.$t(
                                        "SeaExport.EuroLineENSDeclaration"
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        ref: "euEnsFilingTag",
                                        attrs: {
                                          label: _vm.$t(
                                            "SeaExport.EuroLineENSDeclaration"
                                          ),
                                          placeholder: " "
                                        },
                                        on: {
                                          change: _vm.onEuEnsFilingTagChange
                                        },
                                        model: {
                                          value: _vm.form.euEnsFilingTag,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "euEnsFilingTag",
                                              $$v
                                            )
                                          },
                                          expression: "form.euEnsFilingTag"
                                        }
                                      },
                                      _vm._l(
                                        _vm.SeaExportConstants
                                          .ENS_DECLARATION_HPL,
                                        function(item, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label:
                                                _vm.$store.getters.language ===
                                                "zh"
                                                  ? item.chineseName
                                                  : item.englishName,
                                              value: item.code
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { width: "350px" },
                                    attrs: { no: "supplementaryDeclarant" }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        class:
                                          _vm.form.euEnsFilingTag ===
                                            _vm.SeaExportConstants
                                              .ENS_DECLARATION_STRAIGHT_SUPPLEMENTARY
                                              .code ||
                                          _vm.form.euEnsFilingTag ===
                                            _vm.SeaExportConstants
                                              .ENS_DECLARATION_HOUSE_SELF
                                              .code ||
                                          _vm.form.euEnsFilingTag ===
                                            _vm.SeaExportConstants
                                              .ENS_DECLARATION_HOUSE_MIXED.code
                                            ? "blue"
                                            : "",
                                        attrs: { slot: "label" },
                                        slot: "label"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "SeaExport.SupplementaryDeclarant"
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    ),
                                    _c("el-input", {
                                      ref: "supplementaryDeclarantEoriNo",
                                      attrs: {
                                        type: "text",
                                        "filter-chars": false
                                      },
                                      on: {
                                        change:
                                          _vm.onOhterSupplementaryDeclarantChange
                                      },
                                      model: {
                                        value:
                                          _vm.form.supplementaryDeclarantEoriNo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "supplementaryDeclarantEoriNo",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.supplementaryDeclarantEoriNo"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { width: "350px" },
                                    attrs: { no: "chemicalType" }
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "blue",
                                      attrs: { slot: "label" },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t("SeaExport.ChemicalIdentifier")
                                        )
                                      },
                                      slot: "label"
                                    }),
                                    _c(
                                      "el-select",
                                      {
                                        ref: "chemicalTag",
                                        attrs: { no: "chemicalTag" },
                                        model: {
                                          value: _vm.form.chemicalTag,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "chemicalTag",
                                              $$v
                                            )
                                          },
                                          expression: "form.chemicalTag"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.ChemicalProduct"
                                            ),
                                            value: true
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.NonChemicalProduct"
                                            ),
                                            value: false
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { width: "350px" },
                                    attrs: {
                                      no: "ucrNo",
                                      label: _vm.$t("SeaExport.UCRNO")
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      ref: "ucrNo",
                                      attrs: {
                                        type: "text",
                                        "filter-chars": false
                                      },
                                      model: {
                                        value: _vm.form.ucrNo,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "ucrNo", $$v)
                                        },
                                        expression: "form.ucrNo"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { width: "350px" },
                                    attrs: {
                                      no: "factoryIdNumber",
                                      label: _vm.$t("SeaExport.FactoryEORI")
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      ref: "factoryIdNumber",
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "SeaExport.ExampleIllustrateEORI"
                                        ),
                                        type: "text",
                                        "filter-chars": false
                                      },
                                      model: {
                                        value: _vm.form.factoryIdNumber,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "factoryIdNumber",
                                            $$v
                                          )
                                        },
                                        expression: "form.factoryIdNumber"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { width: "350px" },
                                    attrs: {
                                      no: "warehouseIdNumber",
                                      label: _vm.$t("SeaExport.WarehouseEORI")
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      ref: "warehouseIdNumber",
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "SeaExport.ExampleIllustrateEORI"
                                        ),
                                        type: "text",
                                        "filter-chars": false
                                      },
                                      model: {
                                        value: _vm.form.warehouseIdNumber,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "warehouseIdNumber",
                                            $$v
                                          )
                                        },
                                        expression: "form.warehouseIdNumber"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { width: "350px" },
                                    attrs: {
                                      no: "lclPersonIdNumber",
                                      label: _vm.$t("SeaExport.LCLPersonEORI")
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      ref: "lclPersonIdNumber",
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "SeaExport.ExampleIllustrateEORI"
                                        ),
                                        type: "text",
                                        "filter-chars": false
                                      },
                                      model: {
                                        value: _vm.form.lclPersonIdNumber,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "lclPersonIdNumber",
                                            $$v
                                          )
                                        },
                                        expression: "form.lclPersonIdNumber"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c("div", { staticClass: "vertical-line" }),
                    _c(
                      "div",
                      { staticClass: "form-section" },
                      [
                        _c(
                          "el-form",
                          {
                            staticStyle: { width: "440px" },
                            attrs: {
                              "label-width": "160px",
                              "label-position": "right"
                            }
                          },
                          [
                            _c(
                              "div",
                              [
                                _c("span", { staticClass: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("SeaExport.Shipper")))
                                ]),
                                _c(
                                  "el-form-item",
                                  [
                                    _c("span", {
                                      attrs: { slot: "label" },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t("SeaExport.PostalInformation2")
                                        )
                                      },
                                      slot: "label"
                                    }),
                                    _c("el-input", {
                                      ref: "shipperPostalInfo",
                                      attrs: {
                                        no: "1",
                                        type: "text",
                                        "filter-chars": false
                                      },
                                      model: {
                                        value: _vm.form.shipperPostalInfo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "shipperPostalInfo",
                                            $$v
                                          )
                                        },
                                        expression: "form.shipperPostalInfo"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "SeaExport.ShipperStreetNumber"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      ref: "shipperStreetNo",
                                      attrs: {
                                        no: "2",
                                        type: "text",
                                        "filter-chars": false
                                      },
                                      model: {
                                        value: _vm.form.shipperStreetNo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "shipperStreetNo",
                                            $$v
                                          )
                                        },
                                        expression: "form.shipperStreetNo"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "SeaExport.ShipperStreetName"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      ref: "shipperStreetName",
                                      attrs: {
                                        no: "3",
                                        type: "text",
                                        "filter-chars": false
                                      },
                                      model: {
                                        value: _vm.form.shipperStreetName,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "shipperStreetName",
                                            $$v
                                          )
                                        },
                                        expression: "form.shipperStreetName"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-tooltip",
                                  { staticClass: "item" },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t("SeaExport.EORICode")
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          ref: "shipperIdNumber",
                                          attrs: {
                                            no: "4",
                                            type: "text",
                                            "filter-chars": false
                                          },
                                          model: {
                                            value: _vm.form.shipperIdNumber,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "shipperIdNumber",
                                                $$v
                                              )
                                            },
                                            expression: "form.shipperIdNumber"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("SeaExport.ShipperZipCode")
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      ref: "shipperPostalCode",
                                      attrs: {
                                        no: "5",
                                        type: "text",
                                        "filter-chars": false
                                      },
                                      model: {
                                        value: _vm.form.shipperPostalCode,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "shipperPostalCode",
                                            $$v
                                          )
                                        },
                                        expression: "form.shipperPostalCode"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "SeaExport.ActualShipperCountry"
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c("cargo-advance-select", {
                                          ref: "shipperCountry",
                                          attrs: {
                                            no: "shipperCountry",
                                            "select-type":
                                              _vm.TYPE_NAMES.basic_data_Country,
                                            filterable: "",
                                            "tag-name": "code",
                                            "show-custom-label-in-option": true,
                                            "custom-label": function(p) {
                                              return (
                                                p.code + "（" + p.name + "）"
                                              )
                                            },
                                            "default-value":
                                              _vm.form.shipperCountry
                                          },
                                          on: {
                                            parentCallBack: function(p) {
                                              _vm.form.shipperCountry = p.value
                                            }
                                          }
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              width: "170px",
                                              "text-align": "center",
                                              color: "black"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "SeaExport.ActualShipperCity"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _c("el-input", {
                                          ref: "shipperCity",
                                          attrs: {
                                            no: "shipperCity",
                                            type: "text",
                                            "filter-chars": false
                                          },
                                          model: {
                                            value: _vm.form.shipperCity,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "shipperCity",
                                                $$v
                                              )
                                            },
                                            expression: "form.shipperCity"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _c("span", { staticClass: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("SeaExport.Consignee")))
                                ]),
                                _c(
                                  "el-form-item",
                                  [
                                    _c("span", {
                                      attrs: { slot: "label" },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t("SeaExport.PostalInformation2")
                                        )
                                      },
                                      slot: "label"
                                    }),
                                    _c("el-input", {
                                      ref: "consigneePostalInfo",
                                      attrs: {
                                        no: "6",
                                        type: "text",
                                        "filter-chars": false
                                      },
                                      model: {
                                        value: _vm.form.consigneePostalInfo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "consigneePostalInfo",
                                            $$v
                                          )
                                        },
                                        expression: "form.consigneePostalInfo"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "SeaExport.ConsigneeStreetNumber"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      ref: "consigneeStreetNo",
                                      attrs: {
                                        no: "7",
                                        type: "text",
                                        "filter-chars": false
                                      },
                                      model: {
                                        value: _vm.form.consigneeStreetNo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "consigneeStreetNo",
                                            $$v
                                          )
                                        },
                                        expression: "form.consigneeStreetNo"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "SeaExport.ConsigneeStreetName"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      ref: "consigneeStreetName",
                                      attrs: {
                                        no: "8",
                                        type: "text",
                                        "filter-chars": false
                                      },
                                      model: {
                                        value: _vm.form.consigneeStreetName,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "consigneeStreetName",
                                            $$v
                                          )
                                        },
                                        expression: "form.consigneeStreetName"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-tooltip",
                                  { staticClass: "item" },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t("SeaExport.EORICode")
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          ref: "consigneeId",
                                          attrs: {
                                            no: "9",
                                            type: "text",
                                            "filter-chars": false
                                          },
                                          model: {
                                            value: _vm.form.consigneeId,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "consigneeId",
                                                $$v
                                              )
                                            },
                                            expression: "form.consigneeId"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "SeaExport.ConsigneeZipCode"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      ref: "consigneePostalCode",
                                      attrs: {
                                        no: "10",
                                        type: "text",
                                        "filter-chars": false
                                      },
                                      model: {
                                        value: _vm.form.consigneePostalCode,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "consigneePostalCode",
                                            $$v
                                          )
                                        },
                                        expression: "form.consigneePostalCode"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "SeaExport.ActualRecipientCountry"
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c("cargo-advance-select", {
                                          ref: "consigneeCountry",
                                          attrs: {
                                            no: "consigneeCountry",
                                            "select-type":
                                              _vm.TYPE_NAMES.basic_data_Country,
                                            filterable: "",
                                            "tag-name": "code",
                                            "show-custom-label-in-option": true,
                                            "custom-label": function(p) {
                                              return (
                                                p.code + "（" + p.name + "）"
                                              )
                                            },
                                            "default-value":
                                              _vm.form.consigneeCountry
                                          },
                                          on: {
                                            parentCallBack: function(p) {
                                              _vm.form.consigneeCountry =
                                                p.value
                                            }
                                          }
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              width: "170px",
                                              "text-align": "center",
                                              color: "black"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "SeaExport.ActualRecipientCity"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _c("el-input", {
                                          ref: "consigneeCity",
                                          attrs: {
                                            no: "consigneeCity",
                                            type: "text",
                                            "filter-chars": false
                                          },
                                          model: {
                                            value: _vm.form.consigneeCity,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "consigneeCity",
                                                $$v
                                              )
                                            },
                                            expression: "form.consigneeCity"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _c("span", { staticClass: "title" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.NotifyParty"))
                                  )
                                ]),
                                _c(
                                  "el-form-item",
                                  [
                                    _c("span", {
                                      attrs: { slot: "label" },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t("SeaExport.PostalInformation2")
                                        )
                                      },
                                      slot: "label"
                                    }),
                                    _c("el-input", {
                                      ref: "notifyPostalInfo",
                                      attrs: {
                                        no: "11",
                                        type: "text",
                                        "filter-chars": false
                                      },
                                      model: {
                                        value: _vm.form.notifyPostalInfo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "notifyPostalInfo",
                                            $$v
                                          )
                                        },
                                        expression: "form.notifyPostalInfo"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-tooltip",
                                  { staticClass: "item" },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "SeaExport.NotifyStreetNumber"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          ref: "notifyStreetNo",
                                          attrs: {
                                            no: "12",
                                            type: "text",
                                            "filter-chars": false
                                          },
                                          model: {
                                            value: _vm.form.notifyStreetNo,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "notifyStreetNo",
                                                $$v
                                              )
                                            },
                                            expression: "form.notifyStreetNo"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-tooltip",
                                  { staticClass: "item" },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "SeaExport.NotifyStreetName"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          ref: "notifyStreetName",
                                          attrs: {
                                            no: "13",
                                            type: "text",
                                            "filter-chars": false
                                          },
                                          model: {
                                            value: _vm.form.notifyStreetName,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "notifyStreetName",
                                                $$v
                                              )
                                            },
                                            expression: "form.notifyStreetName"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-tooltip",
                                  { staticClass: "item" },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t("SeaExport.EORICode")
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          ref: "notifyCodeForManifest",
                                          attrs: {
                                            no: "14",
                                            type: "text",
                                            "filter-chars": false
                                          },
                                          model: {
                                            value:
                                              _vm.form.notifyCodeForManifest,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "notifyCodeForManifest",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.notifyCodeForManifest"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-tooltip",
                                  { staticClass: "item" },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t("SeaExport.NotifyPhone")
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          ref: "notifyPhone",
                                          attrs: {
                                            no: "15",
                                            type: "text",
                                            "filter-chars": false
                                          },
                                          model: {
                                            value: _vm.form.notifyPhone,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "notifyPhone",
                                                $$v
                                              )
                                            },
                                            expression: "form.notifyPhone"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("SeaExport.NotifyZipCode")
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      ref: "notifyPostalCode",
                                      attrs: {
                                        no: "16",
                                        type: "text",
                                        "filter-chars": false
                                      },
                                      model: {
                                        value: _vm.form.notifyPostalCode,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "notifyPostalCode",
                                            $$v
                                          )
                                        },
                                        expression: "form.notifyPostalCode"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "SeaExport.NotificationCountry"
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c("cargo-advance-select", {
                                          ref: "notifyCountry",
                                          attrs: {
                                            no: "notifyCountry",
                                            "select-type":
                                              _vm.TYPE_NAMES.basic_data_Country,
                                            filterable: "",
                                            "tag-name": "code",
                                            "show-custom-label-in-option": true,
                                            "custom-label": function(p) {
                                              return (
                                                p.code + "（" + p.name + "）"
                                              )
                                            },
                                            "default-value":
                                              _vm.form.notifyCountry
                                          },
                                          on: {
                                            parentCallBack: function(p) {
                                              _vm.form.notifyCountry = p.value
                                            }
                                          }
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              width: "170px",
                                              "text-align": "center",
                                              color: "black"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "SeaExport.NotifyPersonCity"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _c("el-input", {
                                          ref: "notifyCity",
                                          attrs: {
                                            no: "notifyCity",
                                            type: "text",
                                            "filter-chars": false
                                          },
                                          model: {
                                            value: _vm.form.notifyCity,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "notifyCity",
                                                $$v
                                              )
                                            },
                                            expression: "form.notifyCity"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm.form.euEnsFilingTag ===
                      _vm.SeaExportConstants.ENS_DECLARATION_HOUSE_CARRIER
                        .code ||
                    _vm.form.euEnsFilingTag ===
                      _vm.SeaExportConstants.ENS_DECLARATION_HOUSE_MIXED.code
                      ? [
                          _c("div", { staticClass: "vertical-line" }),
                          _c(
                            "div",
                            { staticClass: "form-section" },
                            [
                              _c(
                                "el-form",
                                {
                                  staticStyle: { width: "440px" },
                                  attrs: {
                                    "label-width": "160px",
                                    "label-position": "right"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c("span", { staticClass: "title" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("SeaExport.ActualShipper")
                                          )
                                        )
                                      ]),
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "custom-button",
                                          attrs: {
                                            no: "copyActualShipper",
                                            type: "primary"
                                          },
                                          on: {
                                            click: _vm.copyActualShipperOther
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "SeaExport.CopyActualShipper"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "lable-blue",
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.ShipperName"
                                            )
                                          }
                                        },
                                        [
                                          _c("cargo-rich-textarea", {
                                            ref: "actualShipperName",
                                            staticStyle: {
                                              "min-height": "28px"
                                            },
                                            attrs: {
                                              placeholder: _vm.$t(
                                                "SeaExport.Name"
                                              ),
                                              no: "17",
                                              "warning-count": _vm.warningCount,
                                              "is-trim": true,
                                              "disable-enter": true
                                            },
                                            nativeOn: {
                                              dblclick: function($event) {
                                                _vm.showNameAddressDialog(
                                                  _vm.$t(
                                                    "SeaExport.ActualShipper"
                                                  ),
                                                  "actualShipperName",
                                                  "actualShipperAddress"
                                                )
                                              }
                                            },
                                            model: {
                                              value: _vm.form.actualShipperName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "actualShipperName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.actualShipperName"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        [
                                          _c("span", {
                                            staticClass: "blue",
                                            attrs: { slot: "label" },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t(
                                                  "SeaExport.ShipperAddress"
                                                )
                                              )
                                            },
                                            slot: "label"
                                          }),
                                          _c("cargo-rich-textarea", {
                                            ref: "actualShipperAddress",
                                            staticStyle: {
                                              "min-height": "70px"
                                            },
                                            attrs: {
                                              no: "18",
                                              "warning-count": _vm.warningCount,
                                              "is-trim": true
                                            },
                                            nativeOn: {
                                              dblclick: function($event) {
                                                _vm.showNameAddressDialog(
                                                  _vm.$t(
                                                    "SeaExport.ActualShipper"
                                                  ),
                                                  "actualShipperName",
                                                  "actualShipperAddress"
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.form.actualShipperAddress,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "actualShipperAddress",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.actualShipperAddress"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        [
                                          _c("span", {
                                            attrs: { slot: "label" },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t(
                                                  "SeaExport.PostalInformation2"
                                                )
                                              )
                                            },
                                            slot: "label"
                                          }),
                                          _c("el-input", {
                                            ref: "actualShipperPostalInfo",
                                            attrs: {
                                              no: "actualShipperPostalInfo",
                                              type: "text",
                                              "filter-chars": false
                                            },
                                            model: {
                                              value:
                                                _vm.form
                                                  .actualShipperPostalInfo,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "actualShipperPostalInfo",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.actualShipperPostalInfo"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.ShipperStreetNumber"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            ref: "actualShipperStreetNo",
                                            attrs: {
                                              no: "actualShipperStreetNo",
                                              type: "text",
                                              "filter-chars": false
                                            },
                                            model: {
                                              value:
                                                _vm.form.actualShipperStreetNo,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "actualShipperStreetNo",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.actualShipperStreetNo"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.ShipperStreetName"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            ref: "actualShipperStreetName",
                                            attrs: {
                                              no: "actualShipperStreetName",
                                              type: "text",
                                              "filter-chars": false
                                            },
                                            model: {
                                              value:
                                                _vm.form
                                                  .actualShipperStreetName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "actualShipperStreetName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.actualShipperStreetName"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t("SeaExport.EORICode")
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            ref: "actualShipperCodeForManifest",
                                            attrs: {
                                              placeholder: _vm.$t(
                                                "SeaExport.ExampleIllustrateEORI"
                                              ),
                                              no: "22",
                                              type: "text",
                                              "filter-chars": false
                                            },
                                            model: {
                                              value:
                                                _vm.form
                                                  .actualShipperCodeForManifest,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "actualShipperCodeForManifest",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.actualShipperCodeForManifest"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.ShipperZipCode"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            ref: "actualShipperPostalCode",
                                            attrs: {
                                              no: "23",
                                              type: "text",
                                              "filter-chars": false
                                            },
                                            model: {
                                              value:
                                                _vm.form
                                                  .actualShipperPostalCode,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "actualShipperPostalCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.actualShipperPostalCode"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.ActualShipperCountry"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" }
                                            },
                                            [
                                              _c("cargo-advance-select", {
                                                ref: "actualShipperCountry",
                                                attrs: {
                                                  no: "actualShipperCountry",
                                                  "select-type":
                                                    _vm.TYPE_NAMES
                                                      .basic_data_Country,
                                                  filterable: "",
                                                  "tag-name": "code",
                                                  "show-custom-label-in-option": true,
                                                  "custom-label": function(p) {
                                                    return (
                                                      p.code +
                                                      "（" +
                                                      p.name +
                                                      "）"
                                                    )
                                                  },
                                                  "default-value":
                                                    _vm.form
                                                      .actualShipperCountry
                                                },
                                                on: {
                                                  parentCallBack: function(p) {
                                                    _vm.form.actualShipperCountry =
                                                      p.value
                                                  }
                                                }
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    width: "170px",
                                                    "text-align": "center",
                                                    color: "black"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "SeaExport.ActualShipperCity"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c("el-input", {
                                                ref: "actualShipperCity",
                                                attrs: {
                                                  no: "actualShipperCity",
                                                  type: "text",
                                                  "filter-chars": false
                                                },
                                                model: {
                                                  value:
                                                    _vm.form.actualShipperCity,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "actualShipperCity",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.actualShipperCity"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _c("span", { staticClass: "title" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("SeaExport.ActualConsignee")
                                          )
                                        )
                                      ]),
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "custom-button",
                                          attrs: {
                                            no: "copyBusiness",
                                            type: "primary"
                                          },
                                          on: {
                                            click: _vm.copyActualConsigneeOther
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "SeaExport.CopyActualConsignee"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "lable-blue",
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.ConsigneeName"
                                            )
                                          }
                                        },
                                        [
                                          _c("cargo-rich-textarea", {
                                            ref: "actualConsigneeName",
                                            staticStyle: {
                                              "min-height": "28px"
                                            },
                                            attrs: {
                                              placeholder: _vm.$t(
                                                "SeaExport.Name"
                                              ),
                                              no: "24",
                                              "warning-count": _vm.warningCount,
                                              "is-trim": true,
                                              "disable-enter": true
                                            },
                                            nativeOn: {
                                              dblclick: function($event) {
                                                _vm.showNameAddressDialog(
                                                  _vm.$t(
                                                    "SeaExport.ActualConsignee"
                                                  ),
                                                  "actualConsigneeName",
                                                  "actualConsigneeAddress"
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.form.actualConsigneeName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "actualConsigneeName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.actualConsigneeName"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        [
                                          _c("span", {
                                            staticClass: "blue",
                                            attrs: { slot: "label" },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t(
                                                  "SeaExport.ConsigneeAddress"
                                                )
                                              )
                                            },
                                            slot: "label"
                                          }),
                                          _c("cargo-rich-textarea", {
                                            ref: "actualConsigneeAddress",
                                            staticStyle: {
                                              "min-height": "70px"
                                            },
                                            attrs: {
                                              no: "25",
                                              "warning-count": _vm.warningCount,
                                              "is-trim": true
                                            },
                                            nativeOn: {
                                              dblclick: function($event) {
                                                _vm.showNameAddressDialog(
                                                  _vm.$t(
                                                    "SeaExport.ActualConsignee"
                                                  ),
                                                  "actualConsigneeName",
                                                  "actualConsigneeAddress"
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.form.actualConsigneeAddress,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "actualConsigneeAddress",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.actualConsigneeAddress"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        [
                                          _c("span", {
                                            attrs: { slot: "label" },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t(
                                                  "SeaExport.PostalInformation2"
                                                )
                                              )
                                            },
                                            slot: "label"
                                          }),
                                          _c("el-input", {
                                            ref: "actualConsigneePostalInfo",
                                            attrs: {
                                              no: "actualConsigneePostalInfo",
                                              type: "text",
                                              "filter-chars": false
                                            },
                                            model: {
                                              value:
                                                _vm.form
                                                  .actualConsigneePostalInfo,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "actualConsigneePostalInfo",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.actualConsigneePostalInfo"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.ConsigneeStreetNumber"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            ref: "actualConsigneeStreetNo",
                                            attrs: {
                                              no: "actualConsigneeStreetNo",
                                              type: "text",
                                              "filter-chars": false
                                            },
                                            model: {
                                              value:
                                                _vm.form
                                                  .actualConsigneeStreetNo,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "actualConsigneeStreetNo",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.actualConsigneeStreetNo"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.ConsigneeStreetName"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            ref: "actualConsigneeStreetName",
                                            attrs: {
                                              no: "actualConsigneeStreetName",
                                              type: "text",
                                              "filter-chars": false
                                            },
                                            model: {
                                              value:
                                                _vm.form
                                                  .actualConsigneeStreetName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "actualConsigneeStreetName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.actualConsigneeStreetName"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm.form.euEnsFilingTag ===
                                        _vm.SeaExportConstants
                                          .ENS_DECLARATION_HOUSE_CARRIER.code ||
                                      _vm.form.euEnsFilingTag ===
                                        _vm.SeaExportConstants
                                          .ENS_DECLARATION_HOUSE_MIXED.code
                                        ? _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "SeaExport.EORICode"
                                                )
                                              }
                                            },
                                            [
                                              _c("el-input", {
                                                ref: "actualConsigneeIdNumber",
                                                attrs: {
                                                  placeholder: _vm.$t(
                                                    "SeaExport.ExampleIllustrateEORI"
                                                  ),
                                                  no: "29",
                                                  type: "text",
                                                  "filter-chars": false
                                                },
                                                model: {
                                                  value:
                                                    _vm.form
                                                      .actualConsigneeIdNumber,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "actualConsigneeIdNumber",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.actualConsigneeIdNumber"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.ConsigneeZipCode"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            ref:
                                              "actualConsigneeCodeForManifest",
                                            attrs: {
                                              no: "30",
                                              type: "text",
                                              "filter-chars": false
                                            },
                                            model: {
                                              value:
                                                _vm.form
                                                  .actualConsigneeCodeForManifest,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "actualConsigneeCodeForManifest",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.actualConsigneeCodeForManifest"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.ActualRecipientCountry"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" }
                                            },
                                            [
                                              _c("cargo-advance-select", {
                                                ref: "actualConsigneeCountry",
                                                attrs: {
                                                  no: "actualConsigneeCountry",
                                                  "select-type":
                                                    _vm.TYPE_NAMES
                                                      .basic_data_Country,
                                                  filterable: "",
                                                  "tag-name": "code",
                                                  "show-custom-label-in-option": true,
                                                  "custom-label": function(p) {
                                                    return (
                                                      p.code +
                                                      "（" +
                                                      p.name +
                                                      "）"
                                                    )
                                                  },
                                                  "default-value":
                                                    _vm.form
                                                      .actualConsigneeCountry
                                                },
                                                on: {
                                                  parentCallBack: function(p) {
                                                    _vm.form.actualConsigneeCountry =
                                                      p.value
                                                  }
                                                }
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    width: "170px",
                                                    "text-align": "center",
                                                    color: "black"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "SeaExport.ActualRecipientCity"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c("el-input", {
                                                ref: "actualConsigneeCity",
                                                attrs: {
                                                  no: "actualConsigneeCity",
                                                  type: "text",
                                                  "filter-chars": false
                                                },
                                                model: {
                                                  value:
                                                    _vm.form
                                                      .actualConsigneeCity,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "actualConsigneeCity",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.actualConsigneeCity"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      : _vm._e(),
                    _vm.form.euEnsFilingTag ===
                      _vm.SeaExportConstants.ENS_DECLARATION_HOUSE_CARRIER
                        .code ||
                    _vm.form.euEnsFilingTag ===
                      _vm.SeaExportConstants.ENS_DECLARATION_STRAIGHT_CARRIER
                        .code
                      ? [
                          _c("div", { staticClass: "vertical-line" }),
                          _c(
                            "div",
                            { staticClass: "form-section" },
                            [
                              _c(
                                "el-form",
                                {
                                  staticStyle: { width: "440px" },
                                  attrs: {
                                    "label-width": "160px",
                                    "label-position": "right"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c("span", { staticClass: "title" }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("SeaExport.Buyer"))
                                        )
                                      ]),
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "custom-button",
                                          attrs: {
                                            no: "CopyActualRecipient",
                                            type: "primary"
                                          },
                                          on: { click: _vm.copyActualRecipient }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "SeaExport.CopyActualRecipient"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "lable-blue",
                                          attrs: {
                                            label: _vm.$t("SeaExport.BuyerName")
                                          }
                                        },
                                        [
                                          _c("cargo-rich-textarea", {
                                            ref: "buyerName",
                                            staticStyle: {
                                              "min-height": "28px"
                                            },
                                            attrs: {
                                              no: "buyerName",
                                              placeholder: _vm.$t(
                                                "SeaExport.Name"
                                              ),
                                              "warning-count": _vm.warningCount,
                                              "is-trim": true,
                                              "disable-enter": true
                                            },
                                            nativeOn: {
                                              dblclick: function($event) {
                                                _vm.showNameAddressDialog(
                                                  _vm.$t("SeaExport.Buyer"),
                                                  "buyerName",
                                                  "buyerAddress"
                                                )
                                              }
                                            },
                                            model: {
                                              value: _vm.form.buyerName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "buyerName",
                                                  $$v
                                                )
                                              },
                                              expression: "form.buyerName"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        [
                                          _c("span", {
                                            staticClass: "blue",
                                            attrs: { slot: "label" },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t("SeaExport.BuyerAddress")
                                              )
                                            },
                                            slot: "label"
                                          }),
                                          _c("cargo-rich-textarea", {
                                            ref: "buyerAddress",
                                            staticStyle: {
                                              "min-height": "70px"
                                            },
                                            attrs: {
                                              no: "buyerAddress",
                                              "warning-count": _vm.warningCount,
                                              "is-trim": true
                                            },
                                            nativeOn: {
                                              dblclick: function($event) {
                                                _vm.showNameAddressDialog(
                                                  _vm.$t("SeaExport.Buyer"),
                                                  "buyerName",
                                                  "buyerAddress"
                                                )
                                              }
                                            },
                                            model: {
                                              value: _vm.form.buyerAddress,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "buyerAddress",
                                                  $$v
                                                )
                                              },
                                              expression: "form.buyerAddress"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        [
                                          _c("span", {
                                            attrs: { slot: "label" },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t(
                                                  "SeaExport.PostalInformation2"
                                                )
                                              )
                                            },
                                            slot: "label"
                                          }),
                                          _c("el-input", {
                                            ref: "buyerPostalInfo",
                                            attrs: {
                                              no: "buyerPostalInfo",
                                              type: "text",
                                              "filter-chars": false
                                            },
                                            model: {
                                              value: _vm.form.buyerPostalInfo,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "buyerPostalInfo",
                                                  $$v
                                                )
                                              },
                                              expression: "form.buyerPostalInfo"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.BuyerStreetNumber"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            ref: "buyerStreetNo",
                                            attrs: {
                                              no: "buyerStreetNo",
                                              type: "text",
                                              "filter-chars": false
                                            },
                                            model: {
                                              value: _vm.form.buyerStreetNo,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "buyerStreetNo",
                                                  $$v
                                                )
                                              },
                                              expression: "form.buyerStreetNo"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.BuyerStreetName"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            ref: "buyerStreetName",
                                            attrs: {
                                              no: "buyerStreetName",
                                              type: "text",
                                              "filter-chars": false
                                            },
                                            model: {
                                              value: _vm.form.buyerStreetName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "buyerStreetName",
                                                  $$v
                                                )
                                              },
                                              expression: "form.buyerStreetName"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm.form.euEnsFilingTag ===
                                        _vm.SeaExportConstants
                                          .ENS_DECLARATION_HOUSE_CARRIER.code ||
                                      _vm.form.euEnsFilingTag ===
                                        _vm.SeaExportConstants
                                          .ENS_DECLARATION_STRAIGHT_CARRIER.code
                                        ? _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "SeaExport.EORICode"
                                                )
                                              }
                                            },
                                            [
                                              _c("el-input", {
                                                ref: "buyerIdNumber",
                                                attrs: {
                                                  placeholder: _vm.$t(
                                                    "SeaExport.ExampleIllustrateEORI"
                                                  ),
                                                  no: "buyerIdNumber",
                                                  type: "text",
                                                  "filter-chars": false
                                                },
                                                model: {
                                                  value: _vm.form.buyerIdNumber,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "buyerIdNumber",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.buyerIdNumber"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.BuyerPostalCode"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            ref: "buyerPostalCode",
                                            attrs: {
                                              no: "buyerPostalCode",
                                              type: "text",
                                              "filter-chars": false
                                            },
                                            model: {
                                              value: _vm.form.buyerPostalCode,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "buyerPostalCode",
                                                  $$v
                                                )
                                              },
                                              expression: "form.buyerPostalCode"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.BuyerCountry"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" }
                                            },
                                            [
                                              _c("cargo-advance-select", {
                                                ref: "buyerCountry",
                                                attrs: {
                                                  no: "buyerCountry",
                                                  "select-type":
                                                    _vm.TYPE_NAMES
                                                      .basic_data_Country,
                                                  filterable: "",
                                                  "tag-name": "code",
                                                  "show-custom-label-in-option": true,
                                                  "custom-label": function(p) {
                                                    return (
                                                      p.code +
                                                      "（" +
                                                      p.name +
                                                      "）"
                                                    )
                                                  },
                                                  "default-value":
                                                    _vm.form.buyerCountry
                                                },
                                                on: {
                                                  parentCallBack: function(p) {
                                                    _vm.form.buyerCountry =
                                                      p.value
                                                  }
                                                }
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    width: "170px",
                                                    "text-align": "center",
                                                    color: "black"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "SeaExport.BuyerCity"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c("el-input", {
                                                ref: "buyerCity",
                                                attrs: {
                                                  no: "buyerCity",
                                                  type: "text",
                                                  "filter-chars": false
                                                },
                                                model: {
                                                  value: _vm.form.buyerCity,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "buyerCity",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.buyerCity"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _c("span", { staticClass: "title" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("RailwayExport.BoxOwner2")
                                          )
                                        )
                                      ]),
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "custom-button",
                                          attrs: {
                                            no: "CopyActualShip",
                                            type: "primary"
                                          },
                                          on: { click: _vm.copyActualShip }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("SeaExport.CopyActualShip")
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "lable-blue",
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.SellerName"
                                            )
                                          }
                                        },
                                        [
                                          _c("cargo-rich-textarea", {
                                            ref: "sellerName",
                                            staticStyle: {
                                              "min-height": "28px"
                                            },
                                            attrs: {
                                              placeholder: _vm.$t(
                                                "SeaExport.Name"
                                              ),
                                              no: "sellerName",
                                              "warning-count": _vm.warningCount,
                                              "is-trim": true,
                                              "disable-enter": true
                                            },
                                            nativeOn: {
                                              dblclick: function($event) {
                                                _vm.showNameAddressDialog(
                                                  _vm.$t(
                                                    "RailwayExport.BoxOwner2"
                                                  ),
                                                  "sellerName",
                                                  "sellerAddress"
                                                )
                                              }
                                            },
                                            model: {
                                              value: _vm.form.sellerName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "sellerName",
                                                  $$v
                                                )
                                              },
                                              expression: "form.sellerName"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        [
                                          _c("span", {
                                            staticClass: "blue",
                                            attrs: { slot: "label" },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t(
                                                  "SeaExport.SellerAddress"
                                                )
                                              )
                                            },
                                            slot: "label"
                                          }),
                                          _c("cargo-rich-textarea", {
                                            ref: "sellerAddress",
                                            staticStyle: {
                                              "min-height": "70px"
                                            },
                                            attrs: {
                                              no: "sellerAddress",
                                              "warning-count": _vm.warningCount,
                                              "is-trim": true
                                            },
                                            nativeOn: {
                                              dblclick: function($event) {
                                                _vm.showNameAddressDialog(
                                                  _vm.$t(
                                                    "RailwayExport.BoxOwner2"
                                                  ),
                                                  "sellerName",
                                                  "sellerAddress"
                                                )
                                              }
                                            },
                                            model: {
                                              value: _vm.form.sellerAddress,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "sellerAddress",
                                                  $$v
                                                )
                                              },
                                              expression: "form.sellerAddress"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        [
                                          _c("span", {
                                            attrs: { slot: "label" },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t(
                                                  "SeaExport.PostalInformation2"
                                                )
                                              )
                                            },
                                            slot: "label"
                                          }),
                                          _c("el-input", {
                                            ref: "sellerPostalInfo",
                                            attrs: {
                                              no: "sellerPostalInfo",
                                              type: "text",
                                              "filter-chars": false
                                            },
                                            model: {
                                              value: _vm.form.sellerPostalInfo,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "sellerPostalInfo",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.sellerPostalInfo"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.SellerStreetNumber"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            ref: "sellerStreetNo",
                                            attrs: {
                                              no: "sellerStreetNo",
                                              type: "text",
                                              "filter-chars": false
                                            },
                                            model: {
                                              value: _vm.form.sellerStreetNo,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "sellerStreetNo",
                                                  $$v
                                                )
                                              },
                                              expression: "form.sellerStreetNo"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.SellerStreetName"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            ref: "sellerStreetName",
                                            attrs: {
                                              no: "sellerStreetName",
                                              type: "text",
                                              "filter-chars": false
                                            },
                                            model: {
                                              value: _vm.form.sellerStreetName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "sellerStreetName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.sellerStreetName"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm.form.euEnsFilingTag ===
                                        _vm.SeaExportConstants
                                          .ENS_DECLARATION_HOUSE_CARRIER.code ||
                                      _vm.form.euEnsFilingTag ===
                                        _vm.SeaExportConstants
                                          .ENS_DECLARATION_STRAIGHT_CARRIER.code
                                        ? _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "SeaExport.EORICode"
                                                )
                                              }
                                            },
                                            [
                                              _c("el-input", {
                                                ref: "sellerIdNumber",
                                                attrs: {
                                                  placeholder: _vm.$t(
                                                    "SeaExport.ExampleIllustrateEORI"
                                                  ),
                                                  no: "sellerIdNumber",
                                                  type: "text",
                                                  "filter-chars": false
                                                },
                                                model: {
                                                  value:
                                                    _vm.form.sellerIdNumber,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "sellerIdNumber",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.sellerIdNumber"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.SellerPostalCode"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            ref: "sellerPostalCode",
                                            attrs: {
                                              no: "sellerPostalCode",
                                              type: "text",
                                              "filter-chars": false
                                            },
                                            model: {
                                              value: _vm.form.sellerPostalCode,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "sellerPostalCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.sellerPostalCode"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.SellerCountry"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" }
                                            },
                                            [
                                              _c("cargo-advance-select", {
                                                ref: "sellerCountry",
                                                attrs: {
                                                  no: "sellerCountry",
                                                  "select-type":
                                                    _vm.TYPE_NAMES
                                                      .basic_data_Country,
                                                  filterable: "",
                                                  "tag-name": "code",
                                                  "show-custom-label-in-option": true,
                                                  "custom-label": function(p) {
                                                    return (
                                                      p.code +
                                                      "（" +
                                                      p.name +
                                                      "）"
                                                    )
                                                  },
                                                  "default-value":
                                                    _vm.form.sellerCountry
                                                },
                                                on: {
                                                  parentCallBack: function(p) {
                                                    _vm.form.sellerCountry =
                                                      p.value
                                                  }
                                                }
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    width: "170px",
                                                    "text-align": "center",
                                                    color: "black"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "SeaExport.SellerCity"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c("el-input", {
                                                ref: "sellerCity",
                                                attrs: {
                                                  no: "sellerCity",
                                                  type: "text",
                                                  "filter-chars": false
                                                },
                                                model: {
                                                  value: _vm.form.sellerCity,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "sellerCity",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.sellerCity"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]
            : _vm._e(),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "save", type: "primary" },
                  on: { click: _vm.save }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.innerVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        2
      ),
      _c("cargo-doc-extend-hpl-copy-dialog", {
        attrs: { visible: _vm.euBolHplCopyDialog.visible },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.euBolHplCopyDialog, "visible", $event)
          },
          selected: _vm.selectHplInfo
        }
      }),
      _c("cargo-doc-extend-copy-dialog", {
        attrs: { visible: _vm.euBolCopyDialog.visible },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.euBolCopyDialog, "visible", $event)
          },
          selected: _vm.selectInfo
        }
      }),
      _c("cargo-doc-extend-other-copy-dialog", {
        attrs: { visible: _vm.euBolOtherCopyDialog.visible },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.euBolOtherCopyDialog, "visible", $event)
          },
          selected: _vm.selectOtherInfo
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.nameAddressDialog.visible,
            title: _vm.nameAddressDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.nameAddressDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            staticStyle: { height: "320px" },
            attrs: { "warning-count": _vm.warningCount },
            model: {
              value: _vm.nameAddressDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.nameAddressDialog, "value", $$v)
              },
              expression: "nameAddressDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.finishNameAddress }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.nameAddressDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }